import {STAFF_LIST, COMPENSATION_LIST, PERFORMANCE_LIST, PERFORMANCE_STATEMENT, COMPENSATION, COMPENSATION_KPI_LIST} from './../actions/ActionTypes';
import InitialState from './InitialState';

const CompensationReducer = (state = InitialState.compensation, action) => {
    switch (action.type) {
        case STAFF_LIST: {
            let data = Object.assign({}, state);

            data.userListData =  action.userListData;
            return data;
        }
        case COMPENSATION_LIST: {
            let data = Object.assign({}, state);

            data.compensationListData =  action.compensationListData;
            return data;
        }

        case PERFORMANCE_LIST: {
            let data = Object.assign({}, state);

            data.performanceData =  action.performanceData;
            return data;
        }

        case PERFORMANCE_STATEMENT: {
            let data = Object.assign({}, state);

            data.statement =  action.statement;
            return data;
        }

        case COMPENSATION: {
            let data = Object.assign({}, state);

            data.compensation =  action.compensation;
            return data;
        }

        case COMPENSATION_KPI_LIST: {
            let data = Object.assign({}, state);

            data.compensationKPIList =  action.compensationKPIList;
            return data;
        }

        default:
            return state;
    }
};

export default CompensationReducer;



// WEBPACK FOOTER //
// ./src/reducers/CompensationProfileReducer.js